import type {
  PickerRailProvider,
  ShellProviderAvailability,
} from "../../cmmd/providerAvailabilityJoin";

/**
 * One rail row's joined availability, as the surfaces that can reach CMMD
 * computed it.
 *
 * Separate from `ServerProvider` because the Offer and a person's authority
 * exist before any Environment can report an installation, and because an
 * Environment can publish a provider the person still cannot use. The reason
 * therefore has to travel beside the snapshot rather than be read off it.
 *
 * Every rail row gets an entry, published or not. The previous shape covered
 * only the providers the eligible filter had dropped, which meant the picker
 * still had to work out for itself why a row was missing.
 */
export interface ModelPickerProviderAvailability {
  readonly provider: PickerRailProvider;
  readonly availability: ShellProviderAvailability;
}

/**
 * The value a call site with no Environment in scope passes explicitly.
 *
 * Settings and a project group's default-model row have no runtime to join
 * against: CMMD's account authority and the Provider Inventory both require
 * one. Passing this by name turns "no join available here" into a choice at
 * the call site instead of an omitted prop, and the rail falls back to what
 * the payload and the Offer alone can prove — the same fallback it always
 * used for an omitted prop, `resolveRailProviderAvailability` in
 * `modelPickerRail.ts`.
 */
export const PROVIDER_AVAILABILITY_PAYLOAD_ONLY: ReadonlyArray<ModelPickerProviderAvailability> =
  [];

export function selectProviderAvailability(
  availability: ReadonlyArray<ModelPickerProviderAvailability> | undefined,
): ReadonlyMap<PickerRailProvider, ShellProviderAvailability> {
  return new Map((availability ?? []).map((entry) => [entry.provider, entry.availability]));
}
